module.exports = __webpack_public_path__ + "h5/img/back_04.84453813.png";